import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { History } from "lucide-react";
import { getProducts, getRecentSlugs, inr } from "@/lib/api";

export const RecentlyViewed = () => {
  const [products, setProducts] = useState([]);
  const [slugs, setSlugs] = useState(getRecentSlugs);

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
  }, []);

  useEffect(() => {
    const onChange = () => setSlugs(getRecentSlugs());
    window.addEventListener("classina:recent", onChange);
    return () => window.removeEventListener("classina:recent", onChange);
  }, []);

  const recent = slugs
    .map((slug) => products.find((p) => p.slug === slug))
    .filter(Boolean)
    .slice(0, 8);

  if (recent.length === 0) return null;

  return (
    <section className="pb-24" data-testid="recently-viewed-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-primary mb-3 flex items-center gap-2">
            <History className="w-3.5 h-3.5" /> Pick up where you left off
          </p>
          <h2 className="font-serif text-2xl md:text-3xl font-medium tracking-tight">Recently viewed</h2>
        </motion.div>

        <div className="mt-8 flex gap-4 overflow-x-auto pb-4 -mx-6 px-6 md:mx-0 md:px-0" data-testid="recently-viewed-rail">
          {recent.map((p) => (
            <Link
              key={p.slug}
              to={`/product/${p.slug}`}
              data-testid={`recent-${p.slug}`}
              className="shrink-0 w-44 text-left bg-white/70 backdrop-blur-sm border border-border/60 rounded-xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 hover:border-primary/30 transition-all duration-300 block"
            >
              <img src={p.image} alt={p.name} className="w-full h-32 object-contain bg-white" />
              <div className="p-3">
                <p className="font-serif text-sm font-medium leading-snug line-clamp-1">{p.name}</p>
                <p className="text-xs font-bold mt-1">{inr(p.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
